<script>
export default {
  name: 'Logout',
  beforeMount() {
    // Fall back to the cached account URL if the logout request itself fails for any reason
    const cachedUrl =
      this.$store.state.user && this.$store.state.user.account
        ? this.$store.state.user.account.customLogoutUrl
        : null;

    // The server returns the account's current custom logout URL (authoritative); use it when present
    this.$http
      .post('/auth/logout')
      .then(res => this.finish(res.data && res.data.logoutUrl ? res.data.logoutUrl : cachedUrl))
      .catch(() => this.finish(cachedUrl));
  },
  methods: {
    finish(logoutUrl) {
      this.$store.commit('unsetUser');
      this.$store.commit('unsetTfa');

      if (logoutUrl) {
        // Ensure an absolute URL so the browser treats it as an external redirect. A value without a
        // scheme (e.g. "example.com") would otherwise be resolved as a relative path within the app.
        const url = /^https?:\/\//i.test(logoutUrl) ? logoutUrl : `https://${logoutUrl}`;
        window.location.href = url;
      } else {
        this.$router.push({ name: 'Login' });
      }
    }
  }
};
</script>

<template>
  <div />
</template>
